// import { GENERATE_URL } from "./helpers/request.js";

import Company from "./Company";
import Room from "./Room";
import Customer from "./Customer";
import CompanyService from "./CompanyService";
import Validation from "./Validation";
import CustomerPackage from "./CustomerPackage";
import Reservation from "./Reservation";
import CompanyUser from "./CompanyUser";
import Auth from "./Auth";
import User from "./User";
export default {
  Company,
  CompanyService,
  Reservation,
  CustomerPackage,
  Validation,
  Customer,
  CompanyUser,
  User,
  Room,
  Auth,
};
